import { render } from "./PhotoAlbums.vue?vue&type=template&id=2a0bbfec"
import script from "./PhotoAlbums.vue?vue&type=script&lang=js"
export * from "./PhotoAlbums.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./PhotoAlbums.vue?vue&type=style&index=0&id=2a0bbfec&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script